import { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux' 
import styled from 'styled-components'
import useGetWindowSize from 'hooks/useGetWindowSize'
import { baseUrl } from 'features/constants'
import { HomeContainer, Wrap3, LpButton  } from './landingPage.styled'
import FooterLP from './FooterLP'
import About from './About'
import OurMission from './OurMission'
import UserType from './UserType'
import Loader from 'loaders/Loader'
import { pastravzta } from 'features/auth/authSlice'
import { FaApple, FaGooglePlay } from 'react-icons/fa'
import { useTranslation } from 'react-i18next'


export default function HomeComponentSmall(props) {

    const { t } = useTranslation('web')

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { user } = useSelector((state) => state.auth)
    const { isLoading, isError, message } = useSelector((state) => state.posts)

    const [imagePath, setImagePath] = useState('prys/lp-church.jpg')

    const [screenWidth, screenHeight] = useGetWindowSize()

    let userName;
    if(user){
      userName = user.name
    }
    const [currentDetail, setCurrentDetail] = useState()
  
    const change = () => { 
      const randomIndex = shareDetailsArray[(Math.floor(Math.random() * shareDetailsArray.length))]
      setCurrentDetail(randomIndex)
    }

    useEffect(() => {

      console.log('pastravzta')

      dispatch(pastravzta())

    }, [])
  
    useEffect(() => { 
      const interval = setInterval(change, 1050)
      return () => clearInterval(interval)
    }, [])
   
    useEffect(() => {
      if (isError) {
        console.log(message)
      }
      if (user) {
        navigate('/home')
      }

      if(screenWidth > 1850){
        setImagePath('lp-church-big.jpg')
      }
      else if(screenWidth < 1850 && screenWidth > 1268){
        setImagePath('lp-church.jpg')
      } 
      else if(screenWidth < 1268 && screenWidth > 768){
        setImagePath('lp-church-small.jpg')
      }

    }, [user, navigate, isError, message, screenWidth])
   
    if (isLoading) {
      return <Loader />
    }
  
    const shareDetailsArray = [
      'Prayer Requests', 'Testimonies', 'Events & Anouncements', 'Church Directory', 'Polls', 'Weekly Bulletin'
    ]


    return (
        <HomeContainer>
            <HCTop>
                <img src={`https://praysely.blob.core.windows.net/images/lp-prys.jpg`} alt={'Praysely'} />  
            </HCTop>
            <HCBottom>
                <h1><LeftHeader>{t('landing.church')} {t('landing.community')} {t('landing.onePlace')}</LeftHeader></h1>
                
                <Details>
                 {t('landing.mobileHeroBody')}
                </Details>

                {/* <LeftDetails>{currentDetail}</LeftDetails> */}

                <Wrap3>  
                <LpButton
                  btnType='join'
                  onClick={() => navigate('/register')}
                  >
                    {t('landing.joinFree')}
                </LpButton> 

                <LpButton
                  onClick={() => navigate('/login')}
                  btnType='cal' 
                  >
                    {t('landing.login')}
                </LpButton>
              </Wrap3> 

              <MobileAvailability>
                <AvailabilityText>{t('landing.availableOn')}</AvailabilityText>
                <StoreBadges>
                  <StoreBadge>
                    <FaApple size={22} />
                    <span>iOS</span>
                  </StoreBadge>
                  <StoreBadge>
                    <FaGooglePlay size={19} />
                    <span>Android</span>
                  </StoreBadge>
                </StoreBadges>
              </MobileAvailability>
                
               
            </HCBottom>
            { props.includeMission ? 
              (
                <OurMission />
              )
              :
              (
                <About />
              )
            } 
            <FooterLP />
        </HomeContainer>
    )
}

const HCTop = styled.div` 
    width: 100%;
    height: fit-content;
    img{
        width: 100%;
        height: auto;
    }
`
const HCBottom = styled.div`
    width: 100%;
    height: 100%;
    margin-top: -7px;
    background-color: #6f952e;
    color: #f2f2f2;
    padding: 20px;

    h1{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: baseline;
        width: 100%;
        text-align: justify;
        font-size: 40px;
        font-weight: 900;
    }


`

const Details = styled.div`
    font-size: 15px;
    margin-top: 30px;
    text-align: left;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 87%;
    line-height: 1.5; 
  //media queries
  @media (max-width: 1750px) { 
  }
  @media (max-width: 1208px) { 
    width: 95%;
  }
  @media (max-width: 768px) {

  }

`

const MobileAvailability = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
  margin-top: 34px;
  padding: 16px;
  width: fit-content;
  max-width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 18px;
  background: rgba(45, 65, 18, 0.24);
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.12) inset,
    0 14px 28px rgba(44, 65, 14, 0.24);
`

const AvailabilityText = styled.span`
  color: rgba(247, 249, 242, 0.78);
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`

const StoreBadges = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`

const StoreBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  width: 126px;
  height: 44px;
  border-radius: 13px;
  background: #f5f5f0;
  color: #1f2a12;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0;
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.7) inset,
    0 8px 18px rgba(51, 76, 17, 0.28);

  svg {
    flex: 0 0 auto;
  }
`

const LeftHeader = styled.div`
  font-size: 30px;
  font-weight: 400; 
  margin-left: 0px;
  text-align: left;
  @media (max-width: 1750px) {
    font-size: 25px;
    margin-left: 0px;
    margin-top: 10px;
  }


`


const LeftDetails = styled.div`
  margin-top: 40px;
  font-size: 15px;
  padding: 20px;
  text-align: left;
  border-radius: 10px;
  background-color: #8fbf3c;
  box-shadow: 3px 3px 7px #49611e;;
  color: #3b5017;
`
 
